export default "__VITE_PUBLIC_ASSET__bdd2927f__"